module.exports = __webpack_public_path__ + "img/schweizerischesObligationenrecht.a486c4da.svg";